import {
  day_row,
  dimensiondata_1_tetelek_group_dimension_1_column,
  megawatt_value_1_data_max,
  year_row_expanded,
  month_row,
  order_1,
  order_2
} from '../../fields';
import { PivotGridConfig } from '../../utils/pivot-grid-config';

export const csucsterhelesConfig: PivotGridConfig = {
  showChart: false,
  filterYear: {
    numberOfYears: 3,
  },
  options: {
    store: {
      version: 4,
      type: 'odata',
      url: 'odata/v4/public/Csucsterheles',
      select: ['date', 'dimension_1', 'value_1'],
      beforeSend: (e: any) => {
        e.headers = {
          Accept: 'application/json;odata.metadata=none',
        };
      },
    },
    retrieveFields: false,
    fields: [
      year_row_expanded,
      month_row,
      day_row,
      ...dimensiondata_1_tetelek_group_dimension_1_column,
      megawatt_value_1_data_max,  order_1,
      order_2
    ],
  },
};
